import React from 'react';
import { object, string } from 'yup';
import { Box, Container, makeStyles, Skeleton, Typography } from '@dxb-web-ui-framework/design-system';
import { FormBuilderPresenter } from '@dxb-web-ui-framework/content-composer/components/FormBuilder/FormBuilderPresenter';
import { useTranslation } from 'react-i18next';
import { useWizardGoToNextStep } from '../../../../../content-composer/src/contexts/ClientSideWizard/hooks';
import { useAuthorizationPayrollLoadingState } from '../../../contexts/Payroll/hooks';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(5),
    },
  },
  loaderContainer: {
    display: 'flex',
    flex: 1,
    gap: theme.spacing(3),
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
      marginTop: theme.spacing(3),
    },
  },
  externalFormBuilderElementWrapperClass: {
    margin: 'auto',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
    },
  },
}));

const RejectReasonStep = () => {
  const { t } = useTranslation();
  const onGoToNextStep = useWizardGoToNextStep();

  //callbacks
  const onSubmit = (formData: { cancellationReason: string }) => {
    onGoToNextStep(formData);
  };

  const classes = useStyles();

  // loading state
  const isLoading = useAuthorizationPayrollLoadingState('isLoadingCheckAuthorization');

  return (
    <Container maxWidth='sm' className={classes.container}>
      {isLoading && (
        <Box className={classes.loaderContainer}>
          <Skeleton width='100%' variant='rect' />
          <Skeleton width='100%' variant='rect' />
        </Box>
      )}
      {!isLoading && (
        <Box>
          <Typography>{t('authorizationsListPage.ApproveRejectFlow.Reason.Title')}</Typography>
          <FormBuilderPresenter
            submitAction={onSubmit}
            externalFormBuilderElementWrapperClass={classes.externalFormBuilderElementWrapperClass}
            formConfig={{
              validationSchema: object({
                cancellationReason: string().required(t('authorizationsListPage.ApproveRejectFlow.Validation.Reason')),
              }),
              components: [
                {
                  label: t('authorizationsListPage.ApproveRejectFlow.Reason.Label'),
                  key: 'cancellationReason',
                  type: 'text',
                  disabled: false,
                },
                {
                  key: 'submitBtn',
                  type: 'submit',
                  properties: {
                    text: t('authorizationsListPage.ApproveRejectFlow.Submit.Text'),
                    color: 'primary',
                    variant: 'contained',
                    isDisabled: false,
                    dataTestId: 'submit',
                  },
                },
              ],
            }}
          />
        </Box>
      )}
    </Container>
  );
};

export { RejectReasonStep };
